// All of the templates need to be imported explicitly in order for webpack to include them in the build.
// It is important that the template names are lower-case here, because this determines
// the case-sensitive url that webpack-dev-server uses to serve the file.
import "../../templates/appointmentlocationlogmap.html";
import "../../templates/changepassword.html";
import "../../templates/contactus.html";
import "../../templates/customer.html";
import "../../templates/customeradd.html";
import "../../templates/customers.html";
import "../../templates/customersettings.html";
import "../../templates/dashboard.html";
import "../../templates/documentlibrary.html";
import "../../templates/enterpassworddialog.html";
import "../../templates/forgotpassword.html";
import "../../templates/formdataentrycontrol.html";
import "../../templates/gridfiltercontrol.html";
import "../../templates/home.html";
import "../../templates/login.html";
import "../../templates/logincontrol.html";
import "../../templates/managereports.html";
import "../../templates/oauthlogin.html";
import "../../templates/reportviewer.html";
import "../../templates/resetpassword.html";
import "../../templates/samllogin.html";
import "../../templates/selfregistration.html";
import "../../templates/target.html";
import "../../templates/targeteditcontrol.html";
import "../../templates/targetimport.html";
import "../../templates/targets.html";
import "../../templates/targettemplate.html";
import "../../templates/targettemplates.html";
import "../../templates/task.html";
import "../../templates/taskadd.html";
import "../../templates/taskautoadd.html";
import "../../templates/taskcalendar.html";
import "../../templates/taskdashboard.html";
import "../../templates/taskentry.html";
import "../../templates/tasks.html";
import "../../templates/template.html";
import "../../templates/templateaccessrole.html";
import "../../templates/templateaccessroles.html";
import "../../templates/templateform.html";
import "../../templates/templateforms.html";
import "../../templates/templatephrase.html";
import "../../templates/templatephraseimportcontrol.html";
import "../../templates/templatephrases.html";
import "../../templates/templates.html";
import "../../templates/user.html";
import "../../templates/userprofile.html";
import "../../templates/users.html";
import "../../templates/viewreport.html";
import "../../templates/viewreports.html";

// also need to import in any static json files so webpack includes them
import "../../data-files/us-states.json";

import { ChangePasswordController } from "../controllers/changePassword";
import { ContactUsController } from "../controllers/contactUs";
import { CustomerController } from "../controllers/customer";
import { CustomerAddController } from "../controllers/customerAdd";
import { CustomersController } from "../controllers/customers";
import { CustomerSettingsController } from "../controllers/customerSettings";
import { DashboardController } from "../controllers/dashboard";
import { DocumentLibraryController } from "../controllers/documentLibrary";
import { ForgotPasswordController } from "../controllers/forgotPassword";
import { HomeController } from "../controllers/home";
import { LoginController } from "../controllers/login";
import { ManageReportsController } from "../controllers/manageReports";
import { OAuthLoginController } from "../controllers/oauthLogin";
import { ResetPasswordController } from "../controllers/resetPassword";
import { SAMLLoginController } from "../controllers/samlLogin";
import { SelfRegistrationController } from "../controllers/selfRegistration";
import { TargetController } from "../controllers/target";
import { TargetImportController } from "../controllers/targetImport";
import { TargetsController } from "../controllers/targets";
import { TargetTemplateController } from "../controllers/targetTemplate";
import { TargetTemplatesController } from "../controllers/targetTemplates";
import { TaskController } from "../controllers/task";
import { TaskAddController } from "../controllers/taskAdd";
import { TaskAutoAddController} from "../controllers/taskAutoAdd";
import { TaskCalendarController } from "../controllers/taskCalendar";
import { TaskDashboardController } from "../controllers/taskDashboard";
import { TaskEntryController } from "../controllers/taskEntry";
import { TasksController } from "../controllers/tasks";
import { TemplateController } from "../controllers/template";
import { TemplateAccessRoleController } from "../controllers/templateAccessRole";
import { TemplateAccessRolesController } from "../controllers/templateAccessRoles";
import { TemplateFormController } from "../controllers/templateForm";
import { TemplateFormsController } from "../controllers/templateForms";
import { TemplatePhraseController } from "../controllers/templatePhrase";
import { TemplatePhrasesController } from "../controllers/templatePhrases";
import { TemplatesController } from "../controllers/templates";
import { UserController } from "../controllers/user";
import { UserProfileController } from "../controllers/userProfile";
import { UsersController } from "../controllers/users";
import { ViewReportController } from "../controllers/viewReport";
import { ViewReportsController } from "../controllers/viewReports";
import { IController } from "../interfaces/controller";

export function getController(controllerName: string): IController {
    switch (controllerName) {
        case "ChangePassword": return new ChangePasswordController();
        case "ContactUs": return new ContactUsController();
        case "Customer": return new CustomerController();
        case "CustomerAdd": return new CustomerAddController();
        case "CustomerSettings": return new CustomerSettingsController();
        case "Customers": return new CustomersController();
        case "Dashboard": return new DashboardController();
        case "DocumentLibrary": return new DocumentLibraryController();
        case "ForgotPassword": return new ForgotPasswordController();
        case "Home": return new HomeController();
        case "Login": return new LoginController();
        case "ManageReports": return new ManageReportsController();
        case "OAuthLogin": return new OAuthLoginController();
        case "ResetPassword": return new ResetPasswordController();
        case "SAMLLogin": return new SAMLLoginController();
        case "SelfRegistration": return new SelfRegistrationController();
        case "Target": return new TargetController();
        case "TargetImport": return new TargetImportController();
        case "Targets": return new TargetsController();
        case "TargetTemplate": return new TargetTemplateController();
        case "TargetTemplates": return new TargetTemplatesController();
        case "Task": return new TaskController();
        case "TaskAdd": return new TaskAddController();
        case "TaskAutoAdd": return new TaskAutoAddController();
        case "TaskCalendar": return new TaskCalendarController();
        case "TaskDashboard": return new TaskDashboardController();
        case "TaskEntry": return new TaskEntryController();
        case "Tasks": return new TasksController();
        case "Template": return new TemplateController();
        case "TemplateAccessRole": return new TemplateAccessRoleController();
        case "TemplateAccessRoles": return new TemplateAccessRolesController();
        case "TemplateForm": return new TemplateFormController();
        case "TemplateForms": return new TemplateFormsController();
        case "TemplatePhrase": return new TemplatePhraseController();
        case "TemplatePhrases": return new TemplatePhrasesController();
        case "Templates": return new TemplatesController();
        case "User": return new UserController();
        case "UserProfile": return new UserProfileController();
        case "Users": return new UsersController();
        case "ViewReport": return new ViewReportController();
        case "ViewReports": return new ViewReportsController();
    }
    throw new Error("Unable to construct controller named " + controllerName);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/controllerRegistry.ts